import React from 'react';
import PropTypes from 'prop-types';
import InvalidContractNetworkModal from '@blockcatio/tabby-library/lib/components/wallet/InvalidContractNetworkModal';
import LoadingScreenModal from '@blockcatio/tabby-library/lib/components/LoadingScreenModal';
import AddressNotReadableModal from '@blockcatio/tabby-library/lib/components/wallet/AddressNotReadableModal';
import NoBrowserWalletModal from '@blockcatio/tabby-library/lib/components/wallet/NoBrowserWalletModal';
import WalletSelectionContainer from '@blockcatio/tabby-library/lib/components/wallet/WalletSelectionContainer';
import { walletDefinitions } from '@blockcatio/tabby-library/lib/utilities/walletTypes';
import blockingModal from '@blockcatio/tabby-library/lib/utilities/blockingModal';
import classNames from 'classnames';

const WalletGate = ({
  detectedNetwork,
  expectedNetwork,
  children,
  isLoading,
  isLocked,
  isMissingWeb3,
  isNotProvided,
  walletType,
  selectWallet,
  resetWallet,
  wrongNetwork,
  refreshAccount,
  givenProvider,
  supportedWallets,
}) => {
  let modal = null;

  if (wrongNetwork) {
    modal = blockingModal(
      <InvalidContractNetworkModal
        contractNetworkName={expectedNetwork}
        networkName={detectedNetwork}
      />,
      'warning',
    );
  } else if (!walletType) {
    const supportedWalletDefinitions = walletDefinitions.filter(def =>
      supportedWallets.includes(def.type));
    modal = blockingModal(<WalletSelectionContainer
      walletDefinitions={supportedWalletDefinitions}
      onWalletSelect={selectWallet}
      givenProvider={givenProvider}
    />);
  } else if (isMissingWeb3) {
    modal = blockingModal(<NoBrowserWalletModal onBack={resetWallet} />, 'warning');
  } else if (isLocked || isNotProvided) {
    modal = blockingModal(
      <AddressNotReadableModal
        walletType={walletType}
        onRetry={refreshAccount}
        onBack={resetWallet}
      />,
      'warning',
    );
  } else if (isLoading) {
    const loadingMessage = 'Constructing additional pylons...';
    modal = blockingModal(<LoadingScreenModal>{loadingMessage}</LoadingScreenModal>);
  }

  return (
    <div className={classNames({ 'has-modal': modal !== null })}>
      {modal}
      {Array.isArray(children)
        ? children.map(child => React.cloneElement(child, { isLoading }))
        : React.cloneElement(children, { isLoading })}
    </div>
  );
};

WalletGate.defaultProps = {
  isLocked: false,
  isNotProvided: false,
  givenProvider: null,
};

WalletGate.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isLocked: PropTypes.bool,
  isNotProvided: PropTypes.bool,
  wrongNetwork: PropTypes.bool.isRequired,
  isMissingWeb3: PropTypes.bool.isRequired,
  walletType: PropTypes.string.isRequired,
  selectWallet: PropTypes.func.isRequired,
  resetWallet: PropTypes.func.isRequired,
  detectedNetwork: PropTypes.string.isRequired,
  expectedNetwork: PropTypes.string.isRequired,
  refreshAccount: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  givenProvider: PropTypes.shape({}),
  supportedWallets: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default WalletGate;



// WEBPACK FOOTER //
// ./src/components/WalletGate.js